const defaultOptions = {
    withCredentials: true,
    withXSRFToken: true,
}

export default defaultOptions